import LinkInstagram, {
	LinkInstagramProps as _LinkInstagramProps,
} from './LinkInstagram';

export { LinkInstagram };
export type LinkInstagramProps = _LinkInstagramProps;
